import { SxProps } from "@mui/system";

export const spanTitleStyle = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#707172",
}

export const statusStyles: Record<string, SxProps> = {
  IN_PROGRESS: {
    backgroundColor: '#FEF9C3',
    color: '#854D0E',
  },
  BLOCKED: {
    backgroundColor: '#FFF4F4',
    color: '#C92A2A',
  },
  DONE: {
    backgroundColor: '#E1EFE6',
    color: '#388010',
  },
};

export const baseStyle = {
  width: 'fit-content',
  padding: '0 12px',
  borderRadius: '8px',
  fontWeight: '500',
  fontSize: '14px',
  backgroundColor: 'transparent',
  color: '#000',
};

export const spanDescriptionStyle = {
  fontSize: "16px",
  fontWeight: 500,
  color: "#5e6884",
}

export const statusParser: any = {
  processing: 'IN_PROGRESS',
  pending: 'IN_PROGRESS',
  in_progress: 'IN_PROGRESS',
  error: 'BLOCKED',
  processed: 'DONE',
  uploaded: 'DONE',
  success: 'DONE',
};

export const statusIdParsed: (arg0: string) => string = (status: string) => statusParser[`${status.toLowerCase()}`];
